import { eSessionStore } from "./../../modelos/globales.modelo";
import { cTramite } from "./../../modelos/tramite.modelo";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import * as myGlobals from "../../modelos/globales.modelo";
import * as Tramites from "../../modelos/tramite.modelo";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatAccordion } from "@angular/material/expansion";
import { ApiAppService } from "./../../servicios/apiapp.service";

// Declaramos las variables para jQuery
declare let jquery: any;
declare let $: any;

@Component({
    selector: "app-info-tramites",
    templateUrl: "infotramites.component.html",
    styleUrls: ["infotramites.component.css"],
    providers: [ApiAppService],
    standalone: false
})
export class InfoTramitesComponent implements OnInit {
  public aDatos: Tramites.cTramite[];

  @ViewChild("acordeon", { static: true }) oAcordeon: MatAccordion;

  panelOpenState = true;

  constructor(
    public oRouter: Router,
    public _ApiAppService: ApiAppService,
  ) {}

  ngOnInit() {
    $(".capa-cita").addClass("visible");
    this.CargarTodosLosTramitesDocumentos();
  }

  // Carga de todos trámites y documentos del cliente
  CargarTodosLosTramitesDocumentos(): void {
    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Cargando trámites, espere ...",
      "",
    );

    // Comprobamos si existe el solicitante y además tiene citas pendientes

    this._ApiAppService.ObtenerTodosLosDocumentosTramite(0).subscribe(
      (data) => {
        if (!myGlobals.isNullUndefined(data) && data.length > 0) {
          // Convertimos la colección de objetos interface a colección de clases

          this.aDatos = Tramites.convertirAClase(data, 0);
        } else {
          this.aDatos = null;
        }
      },
      (err) => {
        myGlobals.CapturaMensajeHTTP(err, true);
      },
    );
    myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
  }

  // Conectamos con la petición de cita
  PedirCita(oTramite: cTramite) {
    let citatemporal = null;
    if (!myGlobals.isNullUndefined(oTramite)) {
      citatemporal = {
        id_area: oTramite.id_fk_area,
        id_tramite: oTramite.id_tramite,
      };
      myGlobals.setSessionStore(
        myGlobals.eSessionStore.citatemporal,
        JSON.stringify(citatemporal),
      );
      this.oRouter.navigateByUrl("/citas");
    }
  }
}
